import React, { useEffect, useState } from 'react';
import ComponentToPrintOne from '../ListDetailOder/printComponentOne';
import { getPublic } from '../../helpers/api_helper';
import { useParams } from 'react-router';
const PrintBillById = () => {
  const [orderData, setOrderData] = useState(null);
  const { billId } = useParams();
  useEffect(() => {
    if (!billId) return;
    getPublic(`/bills/${billId}`)
      .then((res) => {
        const oder = res.data;
        console.log(oder);
        setOrderData(oder);
      })
  }, [billId]);

  useEffect(() => {
    if (!orderData) return;
    window.print();
  }, [orderData])

  if (!orderData) return <div>Loading...</div>;
  return (
    <div>
      <ComponentToPrintOne
        {
        ...orderData
        }
        addressFullText={orderData?.addressDeliver?.addressFullText}
        listProduct={orderData?.BillDetails}
      />
    </div>
  );
};

export default PrintBillById;